import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=196c258a&scoped=true"
import script from "./forms.vue?vue&type=script&lang=js"
export * from "./forms.vue?vue&type=script&lang=js"
import style0 from "./forms.vue?vue&type=style&index=0&id=196c258a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196c258a",
  null
  
)

export default component.exports